import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_174_1568)">
      <rect y="0.5" width="18" height="18" rx="9" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.994 9.5C17.994 14.464 13.9673 18.488 8.99999 18.488C4.03274 18.488 0.00598145 14.464 0.00598145 9.5C0.00598145 4.53604 4.03274 0.511963 8.99999 0.511963C13.9673 0.511963 17.994 4.53604 17.994 9.5ZM6.45135 13.0768H4.70586C4.33908 13.0768 4.15791 13.0768 4.04744 13.0062C3.92813 12.9289 3.85521 12.8008 3.84638 12.6594C3.83974 12.5292 3.93034 12.3702 4.11151 12.0522L8.42133 4.46065C8.60472 4.13828 8.69751 3.97709 8.81462 3.91748C8.94056 3.85345 9.09081 3.85345 9.21675 3.91748C9.33385 3.97709 9.42665 4.13828 9.61003 4.46065L10.496 6.00626L10.5006 6.01415C10.6986 6.35999 10.7991 6.53537 10.8429 6.71944C10.8915 6.92037 10.8915 7.13234 10.8429 7.33327C10.7987 7.51874 10.6993 7.69539 10.4982 8.04646L8.2344 12.0456L8.22854 12.0559C8.02917 12.4046 7.92813 12.5813 7.78809 12.7146C7.63563 12.8604 7.45224 12.9663 7.25118 13.026C7.06779 13.0768 6.86232 13.0768 6.45135 13.0768ZM10.8593 13.0768H13.3604C13.7293 13.0768 13.915 13.0768 14.0255 13.004C14.1448 12.9267 14.2199 12.7964 14.2266 12.6551C14.2329 12.5291 14.1443 12.3763 13.9707 12.0768C13.9647 12.0666 13.9587 12.0562 13.9526 12.0457L12.6998 9.90392L12.6855 9.8798C12.5095 9.5823 12.4206 9.43206 12.3065 9.37399C12.1806 9.30995 12.0324 9.30995 11.9066 9.37399C11.7917 9.43361 11.6989 9.59038 11.5155 9.90612L10.2671 12.0479L10.2629 12.0553C10.0801 12.3705 9.98878 12.528 9.99537 12.6573C10.0042 12.7986 10.0771 12.9289 10.1964 13.0062C10.3047 13.0768 10.4903 13.0768 10.8593 13.0768Z"
        fill="#E84142"
      />
    </g>
    <defs>
      <clipPath id="clip0_174_1568">
        <rect y="0.5" width="18" height="18" rx="9" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
